
export interface IPhoto {
  _id: string,
  name: string,
  createdAt: string,
  fileType: string,
  key: string,
  size: number,
  tenant: string,
  updatedAt: string,
  url: string,
}

export const emptyPhoto: IPhoto = {
  _id: '',
  name: '',
  createdAt: '',
  fileType: '',
  key: '',
  size: 0,
  tenant: '',
  updatedAt: '',
  url: '',
}